function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import once from 'lodash/once';
export var stringifyParams = function stringifyParams(dataObj) {
  return Object.keys(dataObj).filter(function (key) {
    return dataObj[key];
  }).map(function (key) {
    return "".concat(key, "=").concat(dataObj[key]);
  }).join('&');
};

/**
 * 自定义黄金令箭上报，非曝光和点击场景
 * 获取表：https://dmc.dw.alibaba-inc.com/dm/table/odps.alilog.dwd_lzd_log_hjlj_di/detail/col
 */
export function goldlog(_ref) {
  var _window$goldlog, _window$goldlog$spm_a;
  var key = _ref.key,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'CLK' : _ref$type,
    _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'POST' : _ref$method;
  if (!('spm' in data)) data.spm = (_window$goldlog = window.goldlog) === null || _window$goldlog === void 0 ? void 0 : (_window$goldlog$spm_a = _window$goldlog.spm_ab) === null || _window$goldlog$spm_a === void 0 ? void 0 : _window$goldlog$spm_a.join('.');
  if (!window.goldlog_queue) window.goldlog_queue = [];
  window.goldlog_queue.push({
    action: 'goldlog.record',
    arguments: [key, type, stringifyParams(data), method]
  });
}
/**
 * 手动spm上报，对自动上报无法处理的场景的补充
 */
export function manualSpmReport(_ref2) {
  var _window$goldlog2, _window$goldlog2$spm_;
  var spmc = _ref2.spmc,
    spmd = _ref2.spmd,
    _ref2$data = _ref2.data,
    data = _ref2$data === void 0 ? {} : _ref2$data,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'CLK' : _ref2$type,
    _ref2$method = _ref2.method,
    method = _ref2$method === void 0 ? 'POST' : _ref2$method;
  var code = {
    EXP: '/lzdseller.aplus-manual.exp',
    CLK: '/lzdseller.aplus-manual.clk'
  }[type];
  var spma, spmb;
  if (((_window$goldlog2 = window.goldlog) === null || _window$goldlog2 === void 0 ? void 0 : (_window$goldlog2$spm_ = _window$goldlog2.spm_ab) === null || _window$goldlog2$spm_ === void 0 ? void 0 : _window$goldlog2$spm_.length) === 2) {
    var _window$goldlog$spm_a2 = _slicedToArray(window.goldlog.spm_ab, 2);
    spma = _window$goldlog$spm_a2[0];
    spmb = _window$goldlog$spm_a2[1];
  } else {
    var _document$querySelect;
    // SPM 规范：https://log.alibaba-inc.com/track/help
    spma = (_document$querySelect = document.querySelector('meta[name="data-spm"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.content;
    spmb = document.body.getAttribute('data-spm') || '';
    if (!spma || !spmb) {
      var _document$querySelect2, _document$querySelect3;
      var _ref3 = ((_document$querySelect2 = document.querySelector('meta[name="spm-id"]')) === null || _document$querySelect2 === void 0 ? void 0 : (_document$querySelect3 = _document$querySelect2.content) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.split('.')) || [];
      var _ref4 = _slicedToArray(_ref3, 2);
      spma = _ref4[0];
      spmb = _ref4[1];
    }
    if (!spma || !spmb) return;
  }
  if (!spmc || !spmd) {
    console.error('Please config spmc and spmd');
    return;
  }
  var params = _objectSpread({
    spm: "".concat(spma, ".").concat(spmb, ".").concat(spmc, ".").concat(spmd)
  }, data);
  var query = stringifyParams(params);
  if (!window.goldlog_queue) window.goldlog_queue = [];
  window.goldlog_queue.push({
    action: 'goldlog.record',
    arguments: [code, type, query, method]
  });
}

/**
 * 创建一个时长上报方法，可以被调用2次
 * 第一次开始计时，第二次上报耗时
 * @param params
 */
export function createDurationReport(params) {
  return function () {
    var start = Date.now();
    return once(function () {
      manualSpmReport(_objectSpread(_objectSpread({}, params), {}, {
        data: _objectSpread({
          duration: Date.now() - start
        }, params.data)
      }));
    });
  };
}

/**
 * 对Promise进行时长上报
 * @param params
 * @param fn
 */
export function createPromiseDurationReport(params, fn) {
  var report = createDurationReport(params);
  return function () {
    var end = report();
    return fn.apply(void 0, arguments).then(end);
  };
}

/**
 * 发送PV，一般用于SPA应用
 * @param spmb
 * @param params
 * @returns
 */
export function sendPv(spmb) {
  var _goldlog$setPageSPM, _goldlog$sendPV;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var goldlog = window.goldlog;
  if (!(goldlog !== null && goldlog !== void 0 && goldlog.setPageSPM)) return;
  (_goldlog$setPageSPM = goldlog.setPageSPM) === null || _goldlog$setPageSPM === void 0 ? void 0 : _goldlog$setPageSPM.call(goldlog, null, spmb);
  (_goldlog$sendPV = goldlog.sendPV) === null || _goldlog$sendPV === void 0 ? void 0 : _goldlog$sendPV.call(goldlog, {}, params);
}